import { ReviewApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { GetAllReviewsRequest, GetReviewDetailResponse } from '@/types/http-payload/review';
import { Review } from '@/types/review';

export default class ReviewStore extends BaseStore {
    reviews: Review[] = [];
    totalByStatus: Object = {};
    api: ReviewApi;
    reviewDetail?: GetReviewDetailResponse;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            reviews: observable,
            reviewDetail: observable,
            totalByStatus: observable,
            getAllReviews: flow.bound,
            postSeedingComments: flow.bound,
            editSeedingComments: flow.bound,
            getReviewDetail: flow.bound,
            publishReview: flow.bound,
            deleteReview: flow.bound
        });
        this.api = new ReviewApi();
    }

    *getAllReviews(searchParams: GetAllReviewsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllReviews, payload);
            if (res.ok) {
                this.reviews = res.data.elements;
                this.totalByStatus = res.data.totalByStatus;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *postSeedingComments(data) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.postSeedingComments, data);
            if (res?.ok) {
                return true;
            }
        } catch (error) {
        }
    }

    * editSeedingComments(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.editSeedingComments, payload, { hideLoading: false });
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *getReviewDetail(id: string) {
        try {
            const res: ResponseData<GetReviewDetailResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getReviewDetail, id);
            if (res?.ok) {
                this.reviewDetail = res?.data;
                return res;
            }
        } catch (error) {
        }
    }

    *publishReview(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.publishReview, id);
            if (res?.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *deleteReview(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteReview, id);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean(): void {
        super.clean();
        this.reviews = [];
    }
}
